module.exports = __webpack_public_path__ + "static/img/mobile_bg_peng.45c029d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map/mobile_bg_peng.png
// module id = hEaf
// module chunks = 4